import { useDrawer } from '@cast/design-system';

import { ClusterDetailsDrawer } from '../_components/ClusterDetailsDrawer/ClusterDetailsDrawer';

export const useClusterDetailsDrawer = () => {
  const { open } = useDrawer();

  return {
    openClusterDetailsDrawer: () => {
      open({ component: ClusterDetailsDrawer, props: {} });
    },
  };
};
